import React, { Component } from 'react';
import _ from 'lodash';
import { List, Header, Container } from 'semantic-ui-react';
import he from 'he';

class UnitTestSection extends Component
{
   render()
    {
        if( _.get( this.props, 'report.data.tests.messages.length', 0 ) === 0 )
        {
            return null;
        }

        const entries = _.map(
            this.props.report.data.tests.messages,
            ( message, index ) => {
                return (
                    <List.Item
                            header={he.decode( `${message.classname}: ${message.name}` )}
                            description={he.decode( he.decode( message.failure.message ) )}
                            icon={`warning sign`}
                            key={index}
                    >
                    </List.Item>
                );
            }
        );

        return (
            <Container className='Mocha'>
                <Header size={`large`}>Unit Test Failures</Header>

                <List>
                    {entries}
                </List>
            </Container>
        );
    }
}

export default UnitTestSection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/UnitTest.js